import React from 'react';
import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';
import { CaseMilestoneAction } from 'pages/Cases/hooks/useGetCases';

type ModelSetsTableProps = {
  action: CaseMilestoneAction;
  isDraft?: boolean;
  modelSetName: string;
  slideMode?: boolean;
  groupHeaderHeight?: number;
  columnHeaderHeight?: number;
  rowHeight?: number;
  maxHeight?: number;
  fontSize?: number;
};

// main component

const ModelSetsTable = ({
  action,
  modelSetName,
  slideMode = false,
  groupHeaderHeight = 56,
  columnHeaderHeight = 32,
  rowHeight = 36,
  fontSize = 14,
}: ModelSetsTableProps): JSX.Element => {
  return (
    <SplitModelSetSlideTable
      data={action}
      dataType="cases"
      modelSetName={modelSetName}
      slideMode={slideMode}
      groupHeaderHeight={groupHeaderHeight}
      columnHeaderHeight={columnHeaderHeight}
      rowHeight={rowHeight}
      fontSize={fontSize}
    />
  );
};

export default ModelSetsTable;
